export default "__VITE_ASSET__7ff396fd__"